<template>
  <div id="home">
    <CeNav/>
    <div class="homeHead">
      <Header/>
    </div>

    <!-- 首屏：原 fullpage 第1屏，改为普通流式布局 -->
    <section class="hHero">
      <div class="hHero-in">
        <h1>美橙极速建站系统</h1>
        <p class="hHero-sub">无缝转换PC/手机站</p>
        <p class="hHero-tag">动动鼠标、轻松上手、简单易用</p>
        <div class="hHero-btns">
          <!-- 免费建站：沿用原有 actionFree() 入口（/templates?serviceType=free） -->
          <a href="javascript:" @click="actionFree()" class="hBtn hBtn-primary">免费建站</a>
          <a href="#lead" @click.prevent="goLead" class="hBtn hBtn-outline">留言获取建站方案</a>
        </div>
      </div>
      <div class="hHero-pic"><img src="../../static/images/banner-1.png" alt="建站之星极速版编辑器" width="1680" height="200"></div>
    </section>

    <!-- 原第2屏：极速版优势（手机/电脑统一展示图文；电脑端额外提供演示视频，进入视口才加载播放） -->
    <section class="hSec" id="stepPage">
      <div class="hWrap">
        <div class="pageTitle">
          <p>Advantage</p>
          <h4>极速版优势</h4>
        </div>
        <ul class="hAdv">
          <li>
            <div class="hAdv-pic"><img src="../../static/images/ys-1-400.webp" :srcset="ysSet[0]" sizes="(max-width:767px) 90vw, 30vw" width="720" height="667" alt="操作便捷" loading="lazy"></div>
            <div class="hAdv-txt"><img src="../../static/images/ys-4.png" alt="" width="40" height="40"><dl><dt>操作便捷</dt><dd>预设好的模块<br/>拖拽即可搭建自己的站点</dd></dl></div>
          </li>
          <li>
            <div class="hAdv-pic"><img src="../../static/images/ys-2-400.webp" :srcset="ysSet[1]" sizes="(max-width:767px) 90vw, 30vw" width="720" height="622" alt="响应建站" loading="lazy"></div>
            <div class="hAdv-txt"><img src="../../static/images/ys-5.png" alt="" width="40" height="40"><dl><dt>响应建站</dt><dd>只需制作好PC站点<br/>即同步兼容手机,平板站点</dd></dl></div>
          </li>
          <li>
            <div class="hAdv-pic"><img src="../../static/images/ys-3-400.webp" :srcset="ysSet[2]" sizes="(max-width:767px) 90vw, 30vw" width="720" height="568" alt="海量模板" loading="lazy"></div>
            <div class="hAdv-txt"><img src="../../static/images/ys-6.png" alt="" width="40" height="40"><dl><dt>海量模板</dt><dd>数百套模板覆盖各行各业<br/>满足各种需求</dd></dl></div>
          </li>
        </ul>
        <div class="hVideo" v-if="!isSmall">
          <video :src="videoOn ? videoSrc : null" muted="muted" playsinline loop controls preload="none" id="ysVideo" ref="ysVideo">您的浏览器不支持 video 标签。</video>
        </div>
      </div>
    </section>

    <!-- 原第3屏：模板 + 资讯（数据接口与逻辑不变） -->
    <section class="hSec hSec-gray tempPage" id="tempPage">
      <div class="hWrap">
        <div class="tempMain">
          <div class="pageTitle">
            <p>template</p>
            <h4>精美模板</h4>
          </div>
          <transition name="fade" mode="out-in">
            <Loading v-if="isLoading" />
          </transition>
          <div class="hTpl">
            <ul>
              <li v-for="item in tempData" :key="item.tpl_id">
                <div class="hTpl-pic">
                  <img class="pc" :src="item.tpl_pic_screenshot.replace('http://','https://')" v-if="item.tpl_pic_screenshot" alt="模板电脑版" loading="lazy" width="480" height="360">
                  <img class="ph" :src="'https://screenshots.websiteonline.cn/screenshots/'+item.tpl_name + '-pm.jpg'" v-if="item.tpl_pic_big" alt="模板手机版" loading="lazy" width="300" height="534">
                </div>
                <router-link :to="{path: '/preview', query: {id:item.tpl_id,cateId:item.tpl_category_id}}" target="_blank" class="hTpl-link">在线预览 ›</router-link>
              </li>
            </ul>
          </div>
          <div class="hTpl-set">
            <p>共 <b>{{count}}</b> 套</p>
            <router-link to="/templates" target="_blank" class="hBtn hBtn-line">查看全部</router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="hSec">
      <div class="hWrap">
        <div class="indexNews">
          <div class="pageTitle">
            <p>information</p>
            <h4>资讯</h4>
          </div>
          <div class="hNews">
            <div class="hNews-box">
              <div class="hNews-h">
                <h4>建站知识</h4>
                <router-link :to="{ path: '/news', query: { cid: 'knowledge',page:'1' } }">更多 ›</router-link>
              </div>
              <ul>
                <li v-for="(i,index) in newsByCategory['knowledge']" :key="index">
                  <router-link :to="{path: '/newsDetail', query: {id:i.id}}">
                    <span class="t">{{i.title}}</span>
                    <span class="d">{{ i.published_time }}</span>
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="hNews-box">
              <div class="hNews-h">
                <h4>更新日志</h4>
                <router-link :to="{ path: '/news', query: { cid: 'update',page:'1' } }">更多 ›</router-link>
              </div>
              <ul>
                <li v-for="(i,index) in newsByCategory['update']" :key="index">
                  <router-link :to="{path: '/newsDetail', query: {id:i.id}}">
                    <span class="t">{{i.title}}</span>
                    <span class="d">{{ i.published_time }}</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer/>
  </div>
</template>

<script>

import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Loading from '@/components/Loading'
import CeNav from '@/components/ceNav.vue'

import { getSiteMobanList} from '@/api/template';
import { getNewsList } from '@/api/new';

export default {
  
  components: {
    Header,
    Footer,
    Loading,
    CeNav,
  },
  data () {
    return {
      pageTitle:'极速建站 - 免费响应式自助建站平台 | 美橙互联 | 建站之星',
      pageKeywords:'响应式建站,自适应建站,免费建站,自助建站,智能建站,在线建站工具,自助建站平台,免费网站搭建,企业建站,个人网站建设,网站建设,网站制作,网站设计',
      pageDescription:'极速建站，美橙互联智能建站系统，响应式自助建站平台，支持免费建站，无需技术基础，轻松搭建企业官网、个人网站、产品展示页。支持多终端自适应，让您快速上线专属网站！',
      isSmall: window.innerWidth <= 767,
      videoOn: false,
      videoSrc: 'https://download.cndns.com/doc/cndns/videos/20260106/video.465f4b8.mp4',
      ysSet: [
        require('../../static/images/ys-1-400.webp') + ' 400w, ' + require('../../static/images/ys-1.webp') + ' 720w',
        require('../../static/images/ys-2-400.webp') + ' 400w, ' + require('../../static/images/ys-2.webp') + ' 720w',
        require('../../static/images/ys-3-400.webp') + ' 400w, ' + require('../../static/images/ys-3.webp') + ' 720w'
      ],

      tempView:{
        pageNum: 0,
        pageSize: "100000",
        tpl_belong_color: "",
        tpl_belong_type: "",
        tpl_category_id: 0,
        tpl_id: 0,
        tpl_level:'',
        tpl_price:"2",
        tpl_name: ""
      },
      tempData:[],
      count:'',
      isLoading:true,

      newsByCategory: {
        'knowledge': [], // 建站知识
        'update': []  // 更新日志
      }
    }
  },

  created(){

            // 设置标题
    document.title = this.pageTitle;
    // 设置description
    this.setMetaTag('description', this.pageDescription);
    // 设置keywords
    this.setMetaTag('keywords', this.pageKeywords);

    this.getTemplateList();

    this.loadCategoryNews('knowledge'); // 建站知识
    this.loadCategoryNews('update'); // 更新日志
  },

  mounted(){
    // 从其它页面点“留言”跳转过来（/#lead）时定位到留言表单
    if (this.$route.hash === '#lead') {
      setTimeout(() => this.goLead(), 300);
    }
    // 电脑端演示视频：进入视口才设置 src 并播放，离开暂停（替代原 fullpage onLeave 逻辑）
    const ysVideo = this.$refs.ysVideo;
    if (!ysVideo || !('IntersectionObserver' in window)) return;
    this._io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          this.videoOn = true;
          this.$nextTick(() => {
            const p = ysVideo.play();
            if (p && p.catch) p.catch(() => {});
          });
        } else if (this.videoOn) {
          ysVideo.pause();
        }
      });
    }, { rootMargin: '200px 0px' });
    this._io.observe(ysVideo);
  },
  beforeDestroy() {
    if (this._io) this._io.disconnect();
  },

  methods: {
    async getTemplateList() {
        try {
          const res = await getSiteMobanList();   
          //console.info(res);
          this.tempData  = res.data;
          this.tempData=this.tempData.filter(temp=>temp.tpl_id == '10684'|| temp.tpl_id == '10662' || temp.tpl_id == '10672' || temp.tpl_id == '10671');          
          this.count =res.data.length;
          this.isLoading = false;
      
        } catch (error) {
          console.info("获取模板列表数据异常");
        }      

    },
    goToRegister() {
      const b = sessionStorage.getItem('param_b');
      const targetUrl = b ? `https://www.sitestar.cn/member/register.aspx?b=${encodeURIComponent(b)}` 
                          : 'https://www.sitestar.cn/member/register.aspx';
      window.location.href = targetUrl;
    },
    goLead(){
      const el = document.getElementById('lead');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    actionFree(){
        this.$router.push({ path: '/templates', query: { serviceType:'free'} });
    },
    
    async loadCategoryNews(cid) {
      try {
        const res = await getNewsList(cid, 1); // 默认第一页
        const raw = res.data || {};
        const list = raw.data || [];
        // console.log(list)
        this.$set(this.newsByCategory, cid, list.slice(0, 5)); 
      } catch (error) {
        console.log(`加载类目 ${cid} 新闻失败`, error);
      }
    },

    setMetaTag(name, content) {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    }

  },

  computed:{     
    filteredTemps(){
      let temps = []
      this.tempData.forEach((temp) => {
        if(temp.tpl_id == '10684'|| temp.tpl_id == '10662' || temp.tpl_id == '10672' || temp.tpl_id == '10671'){
          temps.push(temp)
        }
      })
      return temps
    },

  },
  watch: {
    pageTitle(newVal) {
      document.title = newVal;
    },
    pageDescription(newVal) {
      this.setMetaTag('description', newVal);
    },
    pageKeywords(newVal) {
      this.setMetaTag('keywords', newVal);
    }
  },

  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="./Home.responsive.css"></style>



// WEBPACK FOOTER //
// src/views/Home.vue